import { render, staticRenderFns } from "./SPRCheckbox.vue?vue&type=template&id=eacfe994&scoped=true"
import script from "./SPRCheckbox.vue?vue&type=script&lang=js"
export * from "./SPRCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SPRCheckbox.vue?vue&type=style&index=0&id=eacfe994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eacfe994",
  null
  
)

export default component.exports